import { Suspense, useCallback, useState } from 'react';
import { Flex, Typography, VerticalSpacing } from '@banhala/ui-kit';
import { ContentContainer } from '../ContentContainer';
import {
  AiFittingRoomSizeButton,
  MDComment,
  SizeGuideFullLengthVisualContent,
  SizeReviewAnalysis,
} from './components';
import { ProductInfo } from '../ProductInfo';

export interface SizeTabProps {
  url: string;
  focused: boolean;
  onChangeTabHeight: (height: number) => void;
}

export const SizeTab: React.FC<SizeTabProps> = ({
  focused,
  onChangeTabHeight,
}) => {
  const [hasAnalysisData, setHasAnalysisData] = useState(false);
  const [hasVisualGuideData, setHasVisualGuideData] = useState(false);

  const showHeader = hasAnalysisData || hasVisualGuideData;

  const handleAnalysisHasData = useCallback((hasData: boolean) => {
    setHasAnalysisData(hasData);
  }, []);

  const handleVisualGuideHasData = useCallback((hasData: boolean) => {
    setHasVisualGuideData(hasData);
  }, []);

  return (
    <ContentContainer focused={focused}>
      <Flex
        padding={{ top: 16 }}
        onLayout={({ nativeEvent }) => {
          onChangeTabHeight(nativeEvent.layout.height);
        }}
      >
        <Suspense fallback={null}>
          <AiFittingRoomSizeButton />
        </Suspense>

        {showHeader && (
          <Flex gap={2} padding={{ top: 16, bottom: 12, horizontal: 16 }}>
            <Typography type="h5" color="content_primary">
              체형에 맞는 사이즈 가이드
            </Typography>
            <Typography type="body3" color="content_tertiary">
              개인차가 있을 수 있으니 참고용으로 확인해주세요
            </Typography>
          </Flex>
        )}

        <Suspense fallback={null}>
          <SizeReviewAnalysis
            focused={focused}
            onHasData={handleAnalysisHasData}
          />
        </Suspense>
        <Suspense fallback={null}>
          <SizeGuideFullLengthVisualContent
            onHasData={handleVisualGuideHasData}
          />
        </Suspense>
        <Suspense fallback={null}>
          <ProductInfo />
        </Suspense>
        <Suspense fallback={null}>
          <MDComment />
        </Suspense>
        <VerticalSpacing size={64} />
      </Flex>
    </ContentContainer>
  );
};
